import { Injectable } from '@angular/core';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { GlobalConstants } from '../global-constants';

@Injectable({
  providedIn: 'root'
})
export class FormControlUtilitiesService {


  getControl(
    form: FormGroup | FormArray,
    controlName: string
  ): AbstractControl | null {
    let path: string[] = [];
    if(controlName != null){
      path = controlName.split('.');
    }
    
    let control: AbstractControl | null = form;

    for (const segment of path) {
      if (control instanceof FormGroup || control instanceof FormArray) {
        control = control.get(segment) ?? null;
      } else {
        return null;
      }
    }

    return control;
  }

  public isControlValid(form: FormGroup, controlName: string): boolean {
    const control = this.getControl(form, controlName);
    if (control) {
      if (control instanceof FormArray) {
        return this.isSelectGroupValid(form, controlName);
      } else {
        if(control.touched ) {
            return control.valid;
        } else {
          return true;
        }
      }
    }
    return false;
  }

  public isSsnControlValid(form: FormGroup, controlName: string): boolean {
    const control = this.getControl(form, controlName);
    const actualSsn = this.getControl(form, 'actualSsn');
    const ssnRegex = new RegExp(GlobalConstants.ACTUAL_SSN_VALIDATOR_PATTERN);
    if (control) {
      if(control.touched ) {
        if(control.value != null){
          if(control.value.length != 0){
            if(control.value.length === 11 || control.value.length === 9){
              if(ssnRegex.test(actualSsn.value)){
                return control.valid;
              } else {
                form.get(controlName).setErrors({ invalidSsn: true });
                return false;
              }
            } else {
              form.get(controlName).setErrors({ invalidSsn: true });
              return false;
            }
          } else {
            form.get(controlName).setErrors({ required: true });
            return false;
          }
        } else {
          form.get(controlName).setErrors({ required: true });
          return false;
        }
      } else {
        return true;
      }
    }
    form.get(controlName).setErrors({ invalidSsn: true });
    return false;
  }

  ssnLeaveEvent(form: FormGroup, controlName: string, hasSsnMatch: boolean){
    form.get(controlName).markAsTouched();
    form.updateValueAndValidity();
  
    if(form.get(controlName).value != null){
      if(form.get(controlName).value.length != 0){
        let ssnIsValid = this.isSsnControlValid(form , controlName);
        if(ssnIsValid){
          form.get(controlName).setErrors(null);
        } else {
          if(hasSsnMatch){
            form.get(controlName).setErrors({ ssnMatchesEmployee: true });
            form.setErrors({ ssnMatchesEmployee: true });
          }else{
            form.get(controlName).setErrors({ invalidSsn: true });
            form.setErrors({ invalidSsn: true });
          }
        }
      }
    } else {
      form.get(controlName).markAsTouched();
      form.get(controlName).setErrors({ required: true });
      form.setErrors({ required: true });
      this.isSsnControlValid(form , controlName);
    }
    form.updateValueAndValidity();
  }

  isSelectGroupValid(form: FormGroup, controlName: string): boolean {
    const control = this.getControl(form, controlName);
    if (control && control instanceof FormArray) {
      return control.controls.some(
        (select) => select.value !== null && select.value !== ''
      );
    }
    return false;
  }

  toggleIndividualCheckbox(event: Event, key: string, form: FormGroup) {
    // @ts-ignore
    let isChecked = event.detail.checked;
    form.markAsTouched();
    form.markAsDirty();
    form.updateValueAndValidity();
  
    if(isChecked){
      form.get(key).setValue(true);
    } else {
      form.get(key).setValue(false);
    }
    form.updateValueAndValidity();

    this.setCheckboxFormValid(form);
  }

  setCheckboxFormValid(form: FormGroup, selectedMaximum?: number): boolean { 
    //set the checkboxFormValid to true if there is at least one checkbox checked
    let checked = 0;

    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];

      if (control.value === true) {
        checked ++;
      }
    });

    
    if (checked > 0) {
      if(selectedMaximum != null && selectedMaximum !== undefined && selectedMaximum.toString() !== ""){
        if(checked > selectedMaximum){
          return false;
        } else {
          return true;
        }
      }
      return true;
    } else {
      if(form.touched){
        return false;
      } else {
        if(selectedMaximum != null && selectedMaximum !== undefined && selectedMaximum.toString() !== ""){
        if(checked > selectedMaximum){
            return false;
          } else {
            return true;
          }
        }
        return true;
      }
    }
  }



  public checkIfControlIsTouchedAndNotNullOrEmpty(form: FormGroup, controlName: string): boolean {
    const control = this.getControl(form, controlName);
    if (control) {
      if (control.touched && control.value != null && control.value !== '') {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  public checkIfMonthControlIsBetweenOneAndTwelve(form: FormGroup, controlName: string): boolean {
    const control = this.getControl(form, controlName);
    if (control) {
      if (control.touched && control.value != null && control.value !== '') {
        if (control.value >= 1 && control.value <= 12) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return false;
  }

  public checkIfDayControlIsBetweenOneAndThirtyOne(form: FormGroup, controlName: string): boolean {
    const control = this.getControl(form, controlName);
    if (control) {
      if (control.touched && control.value != null && control.value !== '') {
        if (control.value >= 1 && control.value <= 31) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return false;
  }
  public checkIfYearControlIsValid(form: FormGroup, controlName: string, futureDateOk?: boolean): boolean {
    const control = this.getControl(form, controlName);
    if (control) {
      if (control.touched && control.value != null && control.value !== '') {
        let date: Date = new Date();
        let currentYear: number = date.getFullYear();
        let currentMonth: number = date.getMonth() + 1; // Months are zero-based
        let offSetMonth: number = currentMonth + GlobalConstants.ADD_MONTH_IN_DATE;
        if(futureDateOk){
          if(offSetMonth > 12){
            currentYear = currentYear + 1;
          }
        }
        let offset: number = GlobalConstants.MONTH_PICKER_MIN_DATE_YEAR_OFFSET;
        let startYear: number = date.getFullYear() + offset;
        if (control.value >= startYear && control.value <= currentYear) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return false;
  }

}